import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetOperationalCAAMetricsPatientWeekCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: { personaName?: string; date: string }) => {
    return await repository.getOperationalCAAMetricsPatientWeek(params)
  }
}
